import ChinaIcon from "assets/Mobile/icons/china_flag.png";
import EnglishIcon from "assets/Mobile/icons/english_flag.png";

const TurkeyIcon =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><circle cx='256' cy='256' r='256' fill='%23E30A17'/><path fill='%23FFFFFF' d='M266.7 394.7c-76.6 0-138.7-62.1-138.7-138.7s62.1-138.7 138.7-138.7c33.9 0 65 12.2 89.2 32.5-17.8-7.9-37.4-12.3-58.1-12.3-76.6 0-138.7 62.1-138.7 138.7s62.1 138.7 138.7 138.7c20.7 0 40.4-4.4 58.1-12.3-24.2 20.3-55.3 32.5-89.2 32.5z'/><polygon fill='%23FFFFFF' points='334.6,213.3 345.5,247.1 381.1,247.1 352.3,268 363.3,301.8 334.6,280.9 305.8,301.8 316.8,268 288,247.1 323.6,247.1'/></svg>";

export interface ItemLanguageType {
  id: string;
  value: string;
  label: string;
  picture: string;
}
export const languageOptions: ItemLanguageType[] = [
  { id: "tr", value: "tr", label: "Turkish", picture: TurkeyIcon },
  { id: "en", value: "en", label: "English", picture: EnglishIcon },
  {
    id: "zh-TW",
    value: "zh-TW",
    label: "Chinese",
    picture: ChinaIcon,
  },
];
